import script from "./ProductSpotlight.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSpotlight.vue?vue&type=script&setup=true&lang=js"

import "./ProductSpotlight.vue?vue&type=style&index=0&id=28bf3878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28bf3878"]])

export default __exports__